// extracted by mini-css-extract-plugin
export default {"welcome_back_create_account_button":"welcomeBack_welcome_back_create_account_button__8y882","container":"welcomeBack_container__xV6Ph"};